import type { RootState } from '/business/shared/state/store';
import { hasReductionStatementAgreedSelector } from '/business/shared/state/selectors/application/basket_meta/getBasketMetaSelector';

export default (state: RootState) => hasReductionStatementAgreedSelector(state);
